import { render, staticRenderFns } from "./BcScanBarcode.vue?vue&type=template&id=22269c9b"
import script from "./BcScanBarcode.vue?vue&type=script&lang=js"
export * from "./BcScanBarcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports